import { Axios } from '@utils/api/axios-instance.ts';
import { API_ROOT } from '@utils/constants/app-constants.ts';
import {
  LiveSection,
  LiveSectionAction,
  LiveSectionCreate,
  LiveSectionDetail
} from '@utils/types/editors/live-section.ts';

const root = (sessionId: string) =>
  `${API_ROOT}/speech-to-text/session/${encodeURIComponent(sessionId)}/live/sections`;
export const getLiveSections = async (sessionId: string) =>
  (await Axios.get<LiveSection[]>(root(sessionId))).data;
export const getLiveSection = async (sessionId: string, sectionId: string) =>
  (
    await Axios.get<LiveSectionDetail>(
      `${root(sessionId)}/${encodeURIComponent(sectionId)}`
    )
  ).data;
export const createLiveSection = async (
  sessionId: string,
  body: LiveSectionCreate
) => (await Axios.post<LiveSectionDetail>(root(sessionId), body)).data;
export const updateLiveSection = async (
  sessionId: string,
  section: LiveSection,
  action: LiveSectionAction
) =>
  (
    await Axios.patch<LiveSectionDetail>(
      `${root(sessionId)}/${encodeURIComponent(section.section_id)}`,
      { revision: section.revision, action }
    )
  ).data;
